import { Grid, Typography, Table, TableHead, TableBody, TableRow, TableCell, Box, Card, CardContent, LinearProgress } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import SubCard from "../../ui-component/cards/SubCard";
import axios from "axios";
import moment from "moment";

const OrderStatus = ({ singleOrder, orderAwbNumber }) => {
  const [shipShopyTracking, setShipShopyTracking] = useState(null);
  const [loadingTracking, setLoadingTracking] = useState(false);

  useEffect(() => {
    // Fetch ShipShopy tracking if shipping method is SHIPSHOPY
    if (
      singleOrder?.awbNumber &&
      (singleOrder?.shippingMethod === "SHIPSHOPY" || 
       singleOrder?.shippingMethod === "shipShopy" ||
       singleOrder?.orderType === "shipShopy")
    ) {
      fetchShipShopyTracking();
    }
  }, [singleOrder?.awbNumber, singleOrder?.shippingMethod, singleOrder?.orderType]);

  const fetchShipShopyTracking = async () => {
    if (!singleOrder?.awbNumber) return;
    
    setLoadingTracking(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_PATH_BULK}/sales/getShipShopyTracking?awbNumber=${singleOrder.awbNumber}`
      );
      if (response.data.success && response.data.data?.data) {
        setShipShopyTracking(response.data.data.data);
      }
    } catch (error) {
      console.error("Error fetching ShipShopy tracking:", error);
    } finally {
      setLoadingTracking(false);
    }
  };

  // Render ShipShopy tracking
  if (
    singleOrder?.awbNumber &&
    (singleOrder?.shippingMethod === "SHIPSHOPY" || 
     singleOrder?.shippingMethod === "shipShopy" ||
     singleOrder?.orderType === "shipShopy")
  ) {
    return (
      <>
        <Grid item xs={12} container>
          <Grid item xs={12}>
            <SubCard>
              {loadingTracking ? (
                <Box sx={{ p: 3 }}>
                  <LinearProgress />
                  <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
                    Loading tracking information...
                  </Typography>
                </Box>
              ) : shipShopyTracking ? (
                <Card sx={{ boxShadow: 2 }}>
                  <CardContent>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                      ShipShopy Tracking Information
                    </Typography>
                    
                    {/* Order Details */}
                    <Box sx={{ mb: 3 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">
                            Order ID
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {shipShopyTracking.order_id || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">
                            Reference ID
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {shipShopyTracking.refrence_id || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">
                            AWB Number
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: "#1976d2" }}>
                            {shipShopyTracking.awb_number || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">
                            Courier
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {shipShopyTracking.courier || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary">
                            Order Status
                          </Typography>
                          <Typography variant="body1" sx={{ fontWeight: 500 }}>
                            {shipShopyTracking.order_status || "-"}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" color="textSecondary" sx={{ fontWeight: 600 }}>
                            Current Status
                          </Typography>
                          <Typography variant="h6" sx={{ fontWeight: 700, color: "#1976d2", mt: 0.5 }}>
                            {shipShopyTracking.current_status || "-"}
                          </Typography>
                        </Grid>
                        {shipShopyTracking.expected_delivery_date && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="textSecondary">
                              Expected Delivery Date
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              {moment(shipShopyTracking.expected_delivery_date).format("DD-MMM-YYYY")}
                            </Typography>
                          </Grid>
                        )}
                        {shipShopyTracking.status_time && (
                          <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2" color="textSecondary">
                              Status Time
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                              {moment(shipShopyTracking.status_time).format("DD-MMM-YYYY hh:mm A")}
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </Box>

                    {/* Tracking History */}
                    {shipShopyTracking.scan_detail && shipShopyTracking.scan_detail.length > 0 && (
                      <Box>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                          Tracking History
                        </Typography>
                        <Box sx={{ overflowX: "auto" }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell><strong>Date & Time</strong></TableCell>
                                <TableCell><strong>Status</strong></TableCell>
                                <TableCell><strong>Location</strong></TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {shipShopyTracking.scan_detail.map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    {item.date ? moment(item.date).format("DD-MMM-YYYY hh:mm A") : "-"}
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                      {item.status || "-"}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2">
                                      {item.location || "-"}
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Box>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              ) : (
                <Box sx={{ p: 3, textAlign: "center" }}>
                  <Typography variant="body1" color="textSecondary">
                    No tracking information available
                  </Typography>
                </Box>
              )}
            </SubCard>
          </Grid>
        </Grid>
      </>
    );
  }

  // Original tracking for other shipping methods
  return (
    <>
      <Grid item xs={12} container>
        <Grid item xs={!orderAwbNumber ? 6 : 12}>
          <SubCard>
            {/* Update Sinnle awb numbers */}

            {singleOrder.awbNumber &&
            singleOrder?.shippingMethod === "XPRESSBEES" ? (
              <>
                <Grid>
                  <iframe
                    src={`https://www.xpressbees.com/track`}
                    width="100%"
                    height="700"
                  />
                </Grid>
              </>
            ) : (
              <>
                {singleOrder.awbNumber &&
                singleOrder?.shippingMethod === "ROCKETBOX" ? (
                  <Grid>
                    <iframe
                      src={`https://app-cargo.shiprocket.in/p/track-shipment-v2?waybillno=${orderAwbNumber}`}
                      width="100%"
                      height="700"
                    />
                  </Grid>
                ) : (
                  <>
                    <Grid>
                      <iframe
                        src={`https://shiprocket.co/tracking/${orderAwbNumber}`}
                        width="100%"
                        height="700"
                      />
                    </Grid>
                  </>
                )}
              </>
            )}
          </SubCard>
        </Grid>
      </Grid>
    </>
  );
};

export default OrderStatus;
